(function () {
	'use strict';

	angular
		.module('invesfleet')
		.controller('UserFormController', UserFormController);


	UserFormController.$inject = [
        '$stateParams', 'genericDataService', '$rootScope', '$state',
        '$filter', 'ModalService', '$templateCache', 'reportService', 'notificationService',
        '$q', '$scope', 'userService', '$timeout', 'simpleModalService', 'preferences', 'zonaService', 'common', 'logEmpleadosService', 'restrictionService'
	];

    function UserFormController($stateParams, genericDataService,
        $rootScope, $state, $filter, ModalService, $templateCache, reportService, notificationService,
        $q, $scope, userService, $timeout, simpleModalService, preferences, zonaService, common, logEmpleadosService, restrictionService) {

        var id = $stateParams.id;

        var modalTemplate = $templateCache.get('app/views/modals/usuarioTemplate.html');


        var vm = this;
        vm.stateParams = $stateParams;
        vm.loaded = true; 
        vm.count = 0; 
		vm.user = {};
		vm.perfilFlota = {};
		vm.perfilesDeFlotaList = [];
		vm.perfilesDeFlotaListOriginal = [];
		vm.operadorFlota = false;
        vm.operadorMovil = false;
        vm.flotaCheck = true; 
        vm.facturacionCheck = true; 
        vm.entidades = []; 
        vm.empleados = {
            list: [], 
            selected: {
                id: null, 
                descripcion: null
            }
        }; 

        vm.newIp = {};
        vm.tipoPermiso = {
            list: [
                { nombre: 'Permitir', id: 0 },
                { nombre: 'Denegar', id: 1 }],
            selected: { nombre: 'Permitir', id: 0 }
        };

        vm.edit = false; 

        vm.save = save;
        vm.saveAndClose = saveAndClose;
        vm.saveAndNew = saveAndNew;

        vm.accionSaveList = [
            {
                accionTexto: 'Guardar y cerrar',
                accion: vm.saveAndClose,
                selected: computeValueAccionSelected('guardarCerrar')
            },
            {
                accionTexto: 'Guardar y nuevo',
                accion: vm.saveAndNew,
                selected: computeValueAccionSelected('saveAndNew')
            },
            {
                accionTexto: 'Guardar',
                accion: vm.save,
                selected: computeValueAccionSelected('save')
            },
        ];

        vm.genericData = {
			perfilesFlota: {
				list: [],
				selected: {}
            }

        };

        vm.rol = {
            list: [
                { nombre: 'Usuario', id: '72A66F7C-BDF9-48A0-9C15-D43F533DA778' },
                { nombre: 'Administrador', id: 'e413a979-2d86-458b-8187-8732671e1165' }

            ],
            selected: { nombre: 'Usuario', id: '72A66F7C-BDF9-48A0-9C15-D43F533DA778' }
        };

        vm.save = save;
        vm.addRow = addRow; 
        vm.removeRow = removeRow; 
        vm.entidadChange = entidadChange; 

        //INITIALIZER
        (function () {
            //Edit
            if (id != null) {
                vm.loaded = false; 
                vm.edit = true;
                //userService.getUserCustomInfo(id)
                logEmpleadosService.getAllEmpleados().then(function (res) {
                    vm.empleados.list = res;
                    for (var i = 0; i < vm.empleados.list.length; i++) {
                        vm.empleados.list[i].fullName = vm.empleados.list[i].nombre + " " + vm.empleados.list[i].apellidos;
                    }
                    if (vm.user.empleadoId != null) {
                        vm.empleados.selected = vm.empleados.list[vm.empleados.list.findIndex(x => x.empleadoId == vm.user.empleadoId)];
                    } else {
                        vm.empleados.selected = vm.empleados.list[0];
                    }
                });
                userService.getUser(id)
                    .then(function (user) {
                        vm.user = user;

                          if (vm.user.empleadoId != null && vm.empleados.list.length > 0) {
                              vm.empleados.selected = vm.empleados.list[vm.empleados.list.findIndex(x => x.empleadoId == vm.user.empleadoId)];
                          } else {
                              vm.empleados.selected = vm.empleados.list[0];
                          }
                        //set selected of rol
                        if (vm.user.rolid == 'e413a979-2d86-458b-8187-8732671e1165') vm.rol.selected = { nombre: 'Administrador', id: 'e413a979-2d86-458b-8187-8732671e1165' };

                        //set usuariosIps
                        if (vm.user.usuariosIps != null) {
                            vm.user.usuariosIps.forEach(function (element) {
                                element.id = vm.count;
                                element.dirty = 0;
                                vm.count++;
                            });
                        }

                        //set checkbox
                        switch (vm.user.acceso) {
                            case 0:
                                vm.flotaCheck = false;
                                vm.facturacionCheck = false; 
                                break;
                            case 2:
                                vm.flotaCheck = true;
                                vm.facturacionCheck = false;
                                break;
                            case 4:
                                vm.flotaCheck = false;
                                vm.facturacionCheck = true;
                                break;
                            case 6:
                                vm.flotaCheck = true;
                                vm.facturacionCheck = true;
                                break;
                        }
                        vm.loaded = true; 

                        getGenericData();
                    });
            }
            //New
            else {
                vm.user.usuariosIps = []; 
                getGenericData();
            }
		})();

        function getGenericData() {
			genericDataService.getPerfilesDeFlota()
                .then(function (res) {
                    vm.genericData.perfilesFlota.list = res.data; 
                    vm.genericData.perfilesFlota.list.unshift({ descripcion: 'Ninguno', perfilFlotaId: '00000000-0000-0000-0000-000000000000' });

                    var perfilFlota = findByProperty(vm.genericData.perfilesFlota.list, 'perfilFlotaId', vm.user.perfilFlotaId);
                        if (perfilFlota) {
                            vm.genericData.perfilesFlota.selected = perfilFlota;
                        }
                        else {
                            vm.genericData.perfilesFlota.selected = vm.genericData.perfilesFlota.selected = vm.genericData.perfilesFlota.list[0];
                        }

                });
            genericDataService.getEntidadesPersonalized()
                .then(function (res) {
                    if (vm.edit) {
                        res.data.forEach(function (entidad) {
                            var restrictionType = vm.user.restricciones.find(x => x.entidadId == entidad.entidadId);
                            var entity = {};
                            entity.entidad = entidad; 
                            if (restrictionType) {
                                entity.restrictionType = restrictionType.type; 
                                setPermissionCheckbox(entity); 
                            }
                            else {
                                entity.restrictionType = 0; 
                                entity.leer = true; 
                                entity.crear = true;
                                entity.modificar = true;
                                entity.eliminar = true; 
                            }
                            vm.entidades.push(entity); 
                            
                        });
                    }
                    else {
                        res.data.forEach(function (entidad) {
                            vm.entidades.push({ entidad: entidad, restrictionType: 0, crear: true, leer: true, modificar: true, eliminar: true })
                        });
                    }
                });

        }

        function setPermissionCheckbox(entity) {
            entity.crear = true; 
            entity.leer = true; 
            entity.modificar = true; 
            entity.eliminar = true; 

            if ((entity.restrictionType & 8) == 8) entity.crear = false;
            if ((entity.restrictionType & 2) == 2) entity.leer = false;
            if ((entity.restrictionType & 4) == 4) entity.modificar = false;
            if ((entity.restrictionType & 16) == 16) entity.eliminar = false; 

        }

		function findByProperty(array, property, id) {
			if (array === null) { return null; }
			for (var i = 0; i < array.length; i++) {
				if (array[i][property] === id) {
					return array[i];
				}
			}
			return null;
        }

        function entidadChange(entidad, value) {
            if ((entidad.restrictionType & value) == value) {
                entidad.restrictionType -= value;
                
            }
            else {
                entidad.restrictionType += value; 
            }
        }
                             
        function addRow() {
            if (vm.newIp.ip == '') return;
            vm.user.usuariosIps.push({ id: vm.count, ip: vm.newIp.ip, permiso: vm.tipoPermiso.selected.id, dirty: 2 });

            vm.tipoPermiso.selected = { nombre: 'Permitir', id: 0 };
            vm.newIp.ip = '';
            vm.count++;
        };

        function removeRow (index) {
            if (vm.user.usuariosIps[index].dirty == 2) vm.user.usuariosIps.splice(index, 1);
            else if (vm.user.usuariosIps[index].dirty == 0) vm.user.usuariosIps[index].dirty = 1;
        };

        function setRestrictions() {
            //check in order to delete
            if (vm.edit == true) {
                vm.user.restricciones.forEach(function (restriccion) {
                    var found = vm.entidades.find(x => x.entidad.entidadId == restriccion.entidadId);
                    if (found) {
                        if (found.restrictionType == 0) {
                            restriccion.dirty = -1 //delete
                        }
                        else if (found.restrictionType != restriccion.restrictionType) {
                            restriccion.type = found.restrictionType;
                            restriccion.dirty = 1; //update
                        }
                        else {
                            restriccion.dirty = 0; //do nothing
                        }
                        found.found = true; 
                    }
                    else {
                        restriccion.dirty = 0; //do nothing
                    }
                }); 
            }

            //check in order to add 
            vm.entidades.forEach(function (entidad) {
                if (entidad.restrictionType != 0) {
                    if (entidad.found != true) {
                        var restriccion = {}; 
                        restriccion.entidadId = entidad.entidad.entidadId;
                        restriccion.usuarioId = vm.user.usuarioid;
                        restriccion.type = entidad.restrictionType;
                        restriccion.dirty = 2; //create
                        vm.user.restricciones.push(restriccion); 
                    }
                }
            });
        }

        function doSave(action) {
            if  (vm.user.nombre == null || vm.user.nombre == '' || vm.user.nombre == undefined) {
                sendErrorRequire();
                return;
            }

            else if (vm.user.idusuario == null || vm.user.idusuario == '' || vm.user.idusuario == undefined) {
                sendErrorRequire();
                return;
            }

            if (vm.edit == true) {
                if (!restrictionService.hasPermission(4, 'usuario')) return;
            } else {
                if (!restrictionService.hasPermission(1, 'usuario')) return;
            }

            //set combobox to values
            vm.user.rolid = vm.rol.selected.id; 
            vm.user.perfilFlotaId = vm.genericData.perfilesFlota.selected.perfilFlotaId;

            if(vm.edit == true) {
                vm.user.empleadoId = vm.empleados.selected.empleadoId; 
            }

            //set checkbox to values
            var c = 0;
            if (vm.flotaCheck == true) c += 2; 
            if (vm.facturacionCheck == true) c += 4; 
            vm.user.acceso = c; 

            //set restrictions
             setRestrictions(); 


            userService.add(vm.user).then(function (res) {
                sendSAveNotification();
                vm.edit = true;
                if (action === 'saveAndClose') {
                    $state.go('flota.configuracion.listadoUsuarios');
                }
                else if (action === 'saveAndNew') {
                    $state.go('flota.configuracion.nuevoUsuario', { 'accion': 'saveAndNew' });
                }
                else {
                    vm.user = res; 
                }
            });
           
        }

        function save() {
            var action = 'save';
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            doSave(action);
        }

        function saveAndClose() {
            var action = 'saveAndClose';
            doSave(action);
        }

        function saveAndNew() {
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar y nuevo') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            var action = 'saveAndNew';
            doSave(action);
        }

        function sendSAveNotification() {
            notificationService.sendAppNotification({
                message: 'El usuario se ha guardado correctamente',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
        }

        function sendErrorRequire() {
            notificationService.sendAppNotification({
                message: 'Los campos nombre y usuario son obligatorio',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'error'
            });
        }

        function computeValueAccionSelected(accion) {
            if (accion === vm.stateParams.accion) { return true; }
            return false;
        }

		function save() {

			
        }

       
    }


})();
